import {I18n} from '@aws-amplify/core';
import {SetupIntent} from '../types';
import {StatusBadge} from "../profile/StatusBadge.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {NavLink} from 'react-router-dom';

export const getColumns = (onRecordClick?: (record: SetupIntent) => void) => [
    {
        title: I18n.get('Description'),
        width: '1fr',
        render: (item: SetupIntent) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.description || item.id}
            </span>
        ) : (item.description || item.id),
    },
    {
        title: I18n.get('Customer'),
        width: '1fr',
        render: (item: SetupIntent) => item.customerId ? <NavLink to={`/customers/${item.customerId}`}>{item.customerId}</NavLink> : '-',
    },
    {
        title: I18n.get('Payment Method'),
        width: '1fr',
        render: (item: SetupIntent) => item.paymentMethod || '-',
    },
    {
        title: I18n.get('Usage'),
        width: '1fr',
        render: (item: SetupIntent) => item.usage || '-',
    },
    {
        title: I18n.get('Status'),
        width: '1fr',
        render: (item: SetupIntent) => <StatusBadge status={item.status}/>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: SetupIntent) => formatTimestamp(item.created * 1000),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
